// extracted by mini-css-extract-plugin
export default {"container":"AdminTweetList_container__DbTPZ","title":"AdminTweetList_title__BCGAy"};